import { render, staticRenderFns } from "./DayTradePage.vue?vue&type=template&id=3efe7d3e"
import script from "./DayTradePage.vue?vue&type=script&lang=ts"
export * from "./DayTradePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports